"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthModule } from '@shared/auth';
import { CookieModule } from 'ngx-cookie';
import { ErrorTracking } from './error-tracking.service';
import { MemoryLeakTrackingComponent } from './memory-leak-tracking.component';
import { NavigationPerformanceTrackingComponent } from './navigation-performance-tracking.component';
import { PerformanceTracking } from './performance-tracking.service';
import { SyntheticPerformanceTrackingComponent } from './synthetic-performance-tracking.component';
import { TrackingSectionDirective } from './tracking-section.directive';
import { TrackingComponent } from './tracking.component';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingDirective } from './tracking.directive';
import { Tracking } from './tracking.service';
import { UserTimingTrackingComponent } from './user-timing-tracking.component';
var TrackingModule = (function () {
    function TrackingModule() {
    }
    TrackingModule_1 = TrackingModule;
    TrackingModule.initialize = function (config) {
        return {
            ngModule: TrackingModule_1,
            providers: [Tracking, { provide: TRACKING_CONFIG, useValue: config }],
        };
    };
    TrackingModule = TrackingModule_1 = __decorate([
        NgModule({
            imports: [HttpClientModule, AuthModule, CookieModule],
            declarations: [
                TrackingComponent,
                TrackingDirective,
                TrackingSectionDirective,
                NavigationPerformanceTrackingComponent,
                UserTimingTrackingComponent,
                MemoryLeakTrackingComponent,
                SyntheticPerformanceTrackingComponent,
            ],
            exports: [TrackingComponent, TrackingDirective, TrackingSectionDirective],
            providers: [ErrorTracking, PerformanceTracking],
            // Exported to GAF
            entryComponents: [TrackingComponent],
        })
    ], TrackingModule);
    return TrackingModule;
    var TrackingModule_1;
}());
export { TrackingModule };



// WEBPACK FOOTER //
// tracking.module.js